export function formatDateTimeInArabic(incomingDate, lang = 'en') {
    // Format numbers in English (YYYY/MM/DD HH:MM)
    const date = new Date(incomingDate)
    let formattedDate = date.toLocaleString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,

    });
    if (lang == 'ar') {
        // Get Arabic AM/PM
        let arabicPeriod = date.toLocaleString('ar-EG', { hour: '2-digit', hour12: true }).includes('ص') ? 'صباحًا' : 'مساءً';

        // Replace AM/PM with Arabic equivalent
        formattedDate = formattedDate.replace('am', '').replace('pm', '').replace(',', ' - ').trim();

        return formattedDate + ' ' + arabicPeriod;
    }
    else {
        return formattedDate;

    }
}